module.exports = __webpack_public_path__ + "static/media/highlightApproval.9dea54eb.svg";